<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" fill="currentColor">
    <path d="M192 384l320 384l320-384z" />
  </svg>
</template>
